var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_2343",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#2483BC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2803 5.71432C20.0066 5.33796 19.7329 4.99583 19.4249 4.65369L15.3877 7.59608V8.28036H16.7563L20.2803 5.71432",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34755 8.31437L3.72088 5.64569C3.58402 5.81676 3.48138 5.98783 3.34453 6.1589C3.31031 6.19311 3.31031 6.22733 3.2761 6.22733C3.17346 6.3984 3.0366 6.60368 2.93396 6.77475L5.02101 8.31437H7.34755Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0252 9.68301H14.0191V1.67696C13.3691 1.54011 12.6848 1.47168 11.9663 1.47168C11.2478 1.47168 10.5635 1.54011 9.91348 1.67696V9.68301H1.90743C1.77058 10.3331 1.70215 11.0173 1.70215 11.7358C1.70215 12.4543 1.77058 13.1386 1.90743 13.7887H9.91348V21.7947C10.5635 21.9316 11.2478 22 11.9663 22C12.6848 22 13.3691 21.9316 14.0191 21.7947V13.7887H22.0252C22.162 13.1386 22.2305 12.4543 22.2305 11.7358C22.2305 11.0173 22.162 10.3331 22.0252 9.68301Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5449 21.4184V16.6968L5.02087 19.2971C6.01308 20.2209 7.21056 20.9394 8.5449 21.4184",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3877 21.4184C16.722 20.9394 17.9195 20.2209 18.9117 19.2971L15.3877 16.6627V21.4184Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28381 15.1572C2.38646 15.4994 2.52331 15.8073 2.69438 16.1494L4.02872 15.1572H2.28381Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9039 15.1572L21.2383 16.1494C21.3751 15.8415 21.512 15.4994 21.6488 15.1572H19.9039Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05817 13.7887H1.90747C2.01011 14.2677 2.14697 14.7125 2.28382 15.1573H4.02873L2.69439 16.1495C2.9681 16.7311 3.27603 17.2443 3.65238 17.7575L7.17641 15.1573H8.54496V15.8415L4.54194 18.7839L5.02093 19.2629L8.54496 16.6969V21.4184C8.98974 21.5895 9.43452 21.6921 9.91351 21.7947V13.7887H9.05817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0252 13.7887H14.0192V21.7947C14.4982 21.6921 14.9429 21.5552 15.3877 21.4184V16.6969L18.9117 19.2629C19.3907 18.8181 19.8013 18.3391 20.2119 17.8259L16.551 15.1573H18.8775L20.9646 16.6969C21.0672 16.5258 21.1699 16.3205 21.2383 16.1495L19.904 15.1573H21.6489C21.7857 14.7125 21.9226 14.2677 22.0252 13.7887",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 17.7574C3.92605 18.1338 4.19977 18.4759 4.50769 18.8181L8.54493 15.8757V15.1914H7.17637L3.65234 17.7574Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5852 15.1572L20.2461 17.8259C20.3829 17.6548 20.4856 17.4838 20.6224 17.3127C20.6567 17.2785 20.6567 17.2443 20.6909 17.2443C20.7935 17.0732 20.9304 16.8679 21.033 16.6969L18.8775 15.1572H16.5852Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3877 2.05322V6.77474L18.9117 4.17448C17.9195 3.25071 16.722 2.53222 15.3877 2.05322Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5449 2.05322C7.21056 2.53222 6.01308 3.25071 5.02087 4.17448L8.5449 6.80895V2.05322Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6488 8.31441C21.5462 7.97227 21.4093 7.66434 21.2383 7.3222L19.9039 8.31441H21.6488",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02872 8.31441L2.69438 7.3222C2.55752 7.66434 2.42067 7.97227 2.28381 8.31441H4.02872Z",
    fill: "#2A5F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8745 9.68298H21.991C21.8884 9.20399 21.7515 8.75921 21.6146 8.31443H19.8697L21.2041 7.32223C20.9304 6.74059 20.6224 6.22738 20.2461 5.71418L16.7563 8.31443H15.3877V7.63015L19.3907 4.68776L18.9117 4.20877L15.3877 6.77481V2.05329C14.9429 1.88222 14.4982 1.77958 14.0192 1.67694V9.68298H14.8745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90747 9.68298H9.91351V1.67694C9.43452 1.77958 8.98974 1.91644 8.54496 2.05329V6.77481L5.02093 4.20877C4.54194 4.65355 4.13137 5.13254 3.72081 5.64575L7.38169 8.31443H5.05515L2.9681 6.77481C2.86546 6.94588 2.76282 7.15116 2.69439 7.32223L4.02873 8.31443H2.28382C2.14697 8.75921 2.01011 9.20399 1.90747 9.68298Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.24ac3f00f11b364d3f1577a0e836436a.svg";
export { ForwardRef as ReactComponent };